/**
 * お届け目安 (PDP) — wire GET /api/v1/delivery-estimate (DeliveryEstimateController,
 * public token-optional): guest → default 東京都千代田区, member → địa chỉ đăng ký.
 *
 * Render vào mọi [data-delivery-estimate], chọn 1 trong 2 template Joomla theo cờ
 * est_default (shop.estdate_product_detail_ajax.php:36-64):
 *
 * - est_default=false (member có 住所) → arrival_date_product_detail.tpl.php:8-14
 *   `お届け日：「{pref}{city}」には最短で {Y}年{M}月{D}日（{曜}） {時間帯} にお届け可能`
 *   Nhánh today_shipping_flg (:9-10) thay ngày bằng `{deliver_label}（{曜}）`, không có
 *     trước にお届け可能.
 * - est_default=true (guest) → arrival_date_product_detail_default.tpl.php:5
 *   `お届け目安：{pref}には{deliver_label}お届け` — chỉ label tương đối, KHÔNG ngày,
 *   kèm ô 郵便番号 (snippet product-delivery-zip, :12-20).
 * - mode=zip (theme gửi address, KHÔNG dùng ở PDP) → estDate.tpl.php:11, address_after/
 *   time_after do API trả ('には' + 'まで' khi 離島).
 *
 * Ngày cụ thể LUÔN tồn tại: 離島/指定不可 (day=99) → fast_day = +7 ngày với fast_time
 * rỗng (arrival_date.php:186-188), nên KHÔNG được ẩn block khi deliver_label rỗng —
 * deliver_label chỉ có giá trị ở 0/1/2 ngày (getEstDeliverLabel arrival_date.php:621-631).
 *
 * Tra theo 郵便番号 (nút 表示 = cnZ2A.startEstDate(...,2) zip2Addr.js:183-193,250-291):
 *   1. AjaxZip3 → zip thành pref/city/town, rồi setPrefCd map TÊN 都道府県 sang pref_cd
 *      NỘI BỘ COM_M_PREF (東京都=8, KHÔNG phải JIS) — phía Shopify là GET /zip/{7 số}
 *      (ZipLookupService cũng map qua tên).
 *   2. POST shop.getfasttime_ajax kind=2 với prefCd + address = city+town →
 *      getEndTimeDelive_ver2 (shop.getfasttime_ajax.php:58), tức CÙNG thuật toán nhánh
 *      member, KHÔNG phải Cnet_EstDeliver → gọi /delivery-estimate?mode=member.
 *   3. Kết quả render bằng template member → form 郵便番号 biến mất (template member
 *      không chứa form; Joomla thay cả innerHTML của #arrival_pd_*).
 * Joomla lưu zip vào $_SESSION['estdate'] (setEstDateData) nhưng CHỈ khối お届け目安 ở
 * header/module đọc lại (vm_arrivalDate.php:89); `shop.estdate_product_detail_ajax`
 * KHÔNG đọc session → PDP reload là về lại default, nên phía theme cũng không lưu.
 *
 * Chờ window.inkApi (event ink:api:ready). §Loading: fail → clear skeleton (fail-open,
 * KHÔNG kẹt pulse, KHÔNG chặn mua).
 */
(function () {
  'use strict';

  // &nbsp; trong template Joomla (arrival_date_product_detail.tpl.php:12, estDate.tpl.php:11)
  const NBSP = ' ';

  // shop.estdate_ajax.php:35 — text site cũ dùng khi 郵便番号 nhập không đủ/không đúng
  const MSG_INVALID = '郵便番号を正確に入れてください。';
  const MSG_NOT_FOUND = '郵便番号が見つかりません。';

  function fillNodes(build) {
    document.querySelectorAll('[data-delivery-estimate]').forEach((el) => {
      el.textContent = '';
      if (build) el.appendChild(build());
    });
  }

  /** span.daytime của site cũ = đỏ + bold (base.css:4479-4482) */
  function daytime(text) {
    const span = document.createElement('span');
    span.className = 'text-ink-red';
    span.textContent = text;
    return span;
  }

  /** `お届け日：「{pref}{city}」{addressAfter}{daytime}{timeAfter}にお届け可能` */
  function arrivalLine(city, addressAfter, dayText, timeAfter) {
    const frag = document.createDocumentFragment();
    frag.appendChild(document.createTextNode('お届け日：「' + city + '」' + addressAfter));
    frag.appendChild(daytime(dayText));
    frag.appendChild(document.createTextNode(timeAfter + 'にお届け可能'));
    return frag;
  }

  /** `お届け目安：{pref}には{deliver_label}お届け` */
  function forwardLine(prefName, label) {
    const frag = document.createDocumentFragment();
    frag.appendChild(document.createTextNode('お届け目安：' + prefName + 'には'));
    frag.appendChild(daytime(label));
    frag.appendChild(document.createTextNode('お届け'));
    return frag;
  }

  function build(d) {
    const est = d.estimate;
    const pref = d.pref_name || '';
    const fast = est.fast_day || {};

    if (d.est_default) {
      return forwardLine(pref, est.deliver_label || '');
    }

    const city = pref + (d.address || '');

    if (d.mode === 'zip') {
      return arrivalLine(
        city,
        est.address_after || '',
        (est.date_str || '') + NBSP + (est.est_time || ''),
        NBSP + (est.time_after || ''),
      );
    }

    if (est.today_shipping_flg) {
      return arrivalLine(city, 'には最短で', (est.deliver_label || '') + '（' + (fast.wday || '') + '）', '');
    }

    const date = fast.year + '年' + fast.month + '月' + fast.day + '日（' + (fast.wday || '') + '）';
    return arrivalLine(city, 'には最短で', date + NBSP + (est.fast_time || ''), NBSP);
  }

  function zipBlocks() {
    return document.querySelectorAll('[data-delivery-zip]');
  }

  /**
   * Nhánh guest mới có form; sau khi tra xong ẩn hẳn (template member không có form).
   *
   * PC (≥lg) form mở sẵn, SP mở bằng ［お届け先変更］ — port arrival_date_product_detail_default.
   * Trạng thái PC set bằng JS chứ KHÔNG dựa vào `hidden lg:block` trong class: chỉ cần một
   * rule khác đứng sau `.lg\:block` là form câm luôn trên PC mà SP vẫn chạy (nút toggle
   * gỡ `.hidden` trực tiếp nên không dính). Dưới lg không đụng class → giữ nguyên đóng/mở.
   */
  function showZipBlocks(show) {
    const isPc = window.matchMedia('(min-width: 64rem)').matches;
    zipBlocks().forEach((el) => {
      el.hidden = !show;
      const form = el.querySelector('[data-delivery-zip-form]');
      if (form && isPc) form.classList.toggle('hidden', !show);
    });
  }

  function setZipMessage(text) {
    zipBlocks().forEach((el) => {
      const msg = el.querySelector('[data-delivery-zip-msg]');
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle('hidden', !text);
    });
  }

  /** zip2Addr.js:7-8 — 全角数字 → 半角 rồi ghi lại vào ô nhập */
  function normalizeZipInput(input) {
    if (!input) return '';
    const v = (input.value || '').replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0));
    input.value = v;
    return v.replace(/[^0-9]/g, '');
  }

  async function searchByZip(api, block) {
    // Bản gọn (sidebar) gộp 7 số vào 1 ô; bản thường tách 3+4. Cắt ra rồi dùng chung
    // đúng một luồng kiểm tra bên dưới.
    const full = block.querySelector('[data-delivery-zip-full]');
    const digits = full ? normalizeZipInput(full) : '';
    const zip1 = full ? digits.slice(0, 3) : normalizeZipInput(block.querySelector('[data-delivery-zip1]'));
    const zip2 = full ? digits.slice(3, 7) : normalizeZipInput(block.querySelector('[data-delivery-zip2]'));

    // zip2Addr.js:11-16 — chỉ tra khi đủ 3+4 số
    if (zip1.length !== 3 || zip2.length !== 4) {
      setZipMessage(MSG_INVALID);
      return;
    }
    setZipMessage('');

    window.inkProcessing?.show();
    try {
      const zipRes = await api.get('/zip/' + zip1 + zip2);
      const addr = zipRes && zipRes.data;
      if (!addr || !addr.pref_name) {
        setZipMessage(MSG_NOT_FOUND);
        return;
      }

      // address = city + town (zip2Addr.js:271 city_pd + town_pd)
      const params = {
        mode: 'member',
        pref_name: addr.pref_name,
        address: (addr.city || '') + (addr.town || ''),
      };
      if (addr.pref_cd) params.pref_cd = addr.pref_cd;

      const res = await api.get('/delivery-estimate', params);
      const d = res && res.data;
      if (!d || !d.estimate) {
        setZipMessage(MSG_NOT_FOUND);
        return;
      }

      fillNodes(() => build(d));
      showZipBlocks(false);
    } catch (err) {
      console.warn('[pdp] delivery estimate zip search failed', err);
      setZipMessage(MSG_NOT_FOUND);
    } finally {
      window.inkProcessing?.hide();
    }
  }

  function bindZipForm(api) {
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-delivery-zip-toggle]');
      if (toggle) {
        const form = toggle.closest('[data-delivery-zip]')?.querySelector('[data-delivery-zip-form]');
        form?.classList.toggle('hidden');
        return;
      }

      const submit = e.target.closest('[data-delivery-zip-submit]');
      const block = submit && submit.closest('[data-delivery-zip]');
      if (block) searchByZip(api, block);
    });
  }

  async function run(api) {
    const els = document.querySelectorAll('[data-delivery-estimate]');
    if (!els.length) return;
    bindZipForm(api);
    try {
      const j = await api.get('/delivery-estimate');
      const d = j && j.data;
      const est = d && d.estimate;
      if (!d || !est) {
        fillNodes(null);
        return;
      }
      fillNodes(() => build(d));
      showZipBlocks(!!d.est_default);
    } catch (err) {
      console.warn('[pdp] delivery estimate fetch failed', err);
      fillNodes(null);
    }
  }

  if (window.inkApi) {
    run(window.inkApi);
  } else {
    document.addEventListener('ink:api:ready', () => run(window.inkApi), { once: true });
  }
})();
